/**
 * Created by razial on 18.09.2026.
 */

cleverapps.Tool.UI.windows.passLastChance = displayToolWindow(() => {
    new PassLastChanceWindow(cleverapps.missionManager.findLocalPass());
});

(function () {
    const original = MissionsTool.getMissionMenu;

    MissionsTool.getMissionMenu = function (mission) {
        const actions = original.call(this, mission);
        if (!mission.isPassMission()) {
            return actions;
        }

        actions.addStars = function () {
            const amount = parseInt(prompt("enter stars amount"));
            if (amount) {
                cleverapps.missionManager.dispatchEvent(mission.type, { amount });
            }
        };

        actions.setLevel = function () {
            const menu = {};
            const setLevel = function (level) {
                while (mission.logic.progress.level < level) {
                    mission.logic.addProgress(mission.logic.levels[mission.logic.progress.level].task.goal - mission.logic.progress.progress);
                }
            };

            for (let i = 0, l = mission.levels.length; i < l; ++i) {
                menu[`level ${i + 1}`] = setLevel.bind(null, i);
            }
            menu.finish = setLevel.bind(null, mission.levels.length);
            return menu;
        };

        actions.dropAllRewards = function () {
            const toLastBit = function (rewards) {
                return rewards === 0 ? 0 : (1 << (Number(rewards).toString(2).length - 1));
            };

            mission.logic.rewards = toLastBit(mission.logic.rewards);
            mission.logic.premiumRewards = toLastBit(mission.logic.premiumRewards);
            mission.logic.saveProgress();
        };

        actions.reset = function () {
            mission.logic.load({});
            mission.logic.saveProgress();

            cleverapps.missionManager.updateMissionIcon(mission);
        };

        return actions;
    };
}());
